import { BaseUrlFormatter } from "../../../base";
export class WidgetZonesUrlFormatter extends BaseUrlFormatter {
    composeEndpoint(_request) {
        return "api/widgets/markets/v1/zones";
    }
}
//# sourceMappingURL=WidgetZonesUrlFormatter.js.map